import { useState } from "react";
import { useForm } from "react-hook-form";
import { FormattedMessage, useIntl } from "react-intl";
import { Col, Container, Row } from "react-bootstrap";
import Swal from "sweetalert2";

import SectionHead from "./SectionHead";
import server from "../../api/server";
import FileUpload from "./FileUpload";

const Form = ({ formSubtitle, formTitle }) => {
  const { formatMessage } = useIntl();

  const [file, setFile] = useState({});

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    try {
      await server.post("/contactUs", {
        ...data,
        firstName: data?.Name,
        lastName: { file: file?.path || "", project: data?.project },
        // message: " ",
      });
      reset();
      setFile({});
      Swal.fire(
        `${formatMessage({
          id: "thanks",
        })}`,
        `${formatMessage({
          id: "thankMsg",
        })}`,
        "success"
      );
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <div className="order-form py-4">
        <Container>
          <Row className="justify-content-center">
            {(formTitle || formSubtitle) && (
              <Col xl={12} lg={12} md={12} xs={12}>
                <SectionHead subtitle={formSubtitle} title={formTitle} />
              </Col>
            )}
            <Col lg={formSubtitle || formTitle ? 6 : 6} md={12} xs={12}>
              <form onSubmit={handleSubmit(onSubmit)}>
                <Row className="flex-wrap">
                  <Col xs={12}>
                    <div
                      className="form-group"
                      data-aos="fade-up"
                      data-aos-duration="300"
                      data-aos-delay="100"
                    >
                      <input
                        className="form-control"
                        {...register("Name", {
                          required: true,
                        })}
                        placeholder={formatMessage({
                          id: "fullName",
                        })}
                      />
                      {errors?.Name?.type === "required" && (
                        <p className="error-hint">
                          <FormattedMessage id="required" />
                        </p>
                      )}
                    </div>
                  </Col>

                  <Col md={6} sm={6} xs={12}>
                    <div
                      className="form-group"
                      data-aos="fade-up"
                      data-aos-duration="300"
                      data-aos-delay="200"
                    >
                      <input
                        type="email"
                        className="form-control"
                        {...register("email", {
                          required: true,
                        })}
                        placeholder={formatMessage({
                          id: "email",
                        })}
                      />
                      {errors?.email?.type === "required" && (
                        <p className="error-hint">
                          <FormattedMessage id="required" />
                        </p>
                      )}
                    </div>
                  </Col>
                  <Col md={6} sm={6} xs={12}>
                    <div
                      className="form-group"
                      data-aos="fade-up"
                      data-aos-duration="300"
                      data-aos-delay="400"
                    >
                      <input
                        className="form-control"
                        {...register("project", {
                          required: false,
                        })}
                        placeholder={formatMessage({
                          id: "companyName",
                        })}
                      />
                      {errors?.email?.type === "required" && (
                        <p className="error-hint">
                          <FormattedMessage id="required" />
                        </p>
                      )}
                    </div>
                  </Col>
                  <Col md={6} sm={6} xs={12}>
                    <div
                      className="form-group"
                      data-aos="fade-up"
                      data-aos-duration="300"
                      data-aos-delay="300"
                    >
                      <input
                        className="form-control"
                        {...register("phone", {
                          required: true,
                        })}
                        placeholder={formatMessage({
                          id: "phone",
                        })}
                      />
                      {errors?.phone?.type === "required" && (
                        <p className="error-hint">
                          <FormattedMessage id="required" />
                        </p>
                      )}
                    </div>
                  </Col>
                  <Col md={6} sm={6} xs={12}>
                    <div
                      className="form-group"
                      data-aos="fade-up"
                      data-aos-duration="300"
                      data-aos-delay="400"
                    >
                      <FileUpload
                        setSelectedFile={setFile}
                        selectedFile={file}
                        id="image-uploader"
                      />
                      {errors?.file?.type === "required" && (
                        <p className="error-hint">
                          <FormattedMessage id="required" />
                        </p>
                      )}
                    </div>
                  </Col>
                  <Col xs={12}>
                    <div
                      className="form-group "
                      data-aos="fade-up"
                      data-aos-duration="300"
                      data-aos-delay="400"
                    >
                      <textarea
                        className="form-control py-2"
                        style={{
                          height: "120px",
                        }}
                        {...register("message", {
                          required: true,
                        })}
                        placeholder={formatMessage({
                          id: "message",
                        })}
                      />
                      {errors?.message?.type === "required" && (
                        <p className="error-hint">
                          <FormattedMessage id="required" />
                        </p>
                      )}
                    </div>
                  </Col>
                  <Col sm={12} xs={12}>
                    <div
                      className="form-group"
                      data-aos="fade-up"
                      data-aos-duration="300"
                      data-aos-delay="500"
                    >
                      <button type="submit" className="btn  ">
                        <FormattedMessage id="send" />
                      </button>
                    </div>
                  </Col>
                </Row>
                <Row></Row>
              </form>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Form;
